const reasons = {
  inDelay: 'service in delay',
  inDelayMany: 'services in delay',
  notDone: 'mandatory service not done',
  notDoneMany: 'mandatory services not done',
  hasActionsOpenedOrOverdue: 'service has opened or overdue actions',
  hasActionsOpenedOrOverdueMany: 'services have opened or overdue actions',
  hasNoServices: 'Does not have any service',
}

export default reasons;
